import type { TooltipProps } from 'recharts';

export interface ChartTooltipProps extends TooltipProps<number, string> {
  readonly unit?: string;
}

export function ChartTooltip({ active, payload, label, unit }: ChartTooltipProps): JSX.Element | null {
  if (!active || !payload || payload.length === 0) return null;
  const point = payload[0]!;
  const value = typeof point.value === 'number' ? point.value : Number(point.value);
  return (
    <div
      className="rounded-md border border-border px-3 py-2 text-xs"
      style={{ backgroundColor: 'var(--color-card)' }}
    >
      <div className="font-mono text-[10px] text-text-dim">{formatTime(label)}</div>
      <div className="font-mono text-text">
        {Number.isFinite(value) ? value.toLocaleString() : '—'}
        {unit && <span className="ml-1 text-text-dim">{unit}</span>}
      </div>
    </div>
  );
}

function formatTime(label: unknown): string {
  if (typeof label !== 'number') return '';
  const d = new Date(label);
  return d.toLocaleString();
}
